<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery('dic')">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="关键词">
              <a-input
                placeholder="请输入"
                v-model="queryParam.description"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="话术类型">
              <a-select
                @change="typeIdChange"
                v-model="queryParam.type"
                placeholder="请选择类型"
              >
                <a-select-option
                  v-for="item in typeList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="话术分类">
              <a-select
                @change="categoryChange"
                placeholder="请选择分类"
                v-model="queryParam.category"
              >
                <a-select-option v-for="item in spcenList" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="创建人">
              <a-input
                placeholder="请输入"
                v-model="queryParam.createName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="10">
            <span
              style="float: right; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button
                type="primary"
                @click="searchQuery('dic')"
                icon="search"
                style="margin-right: 8px"
                >查询</a-button
              >
              <a-button type="primary" @click="searchReset" icon="reload"
                >重置</a-button
              >

              <!--展开按钮，控制toggleSearchStatus状态-->
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a> -->
              <!--展开按钮结束 -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div class="table-operator" style="line-height: 40px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新增话术</a-button
      >
    </div>

    <a-table
      ref="table"
      bordered
      size="middle"
      @change="handleTableChange"
      :pagination="ipagination"
      :columns="columns"
      :dataSource="dataSource"
      :rowKey="r => r.id"
      :loading="loading"
    >
      <span slot="status" slot-scope="text, record">
        {{
          record.status == 1
            ? '待审核'
            : record.status == 2
            ? '审核中'
            : record.status == 3
            ? '审核通过'
            : '审核拒绝'
        }}
      </span>
      <span
        v-if="
          record.status != 1 &&
            record.status != 2 &&
            record.typeName != '个人话术'
        "
        slot="action"
        slot-scope="text, record"
      >
        <a @click="handleEdit(record, true)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(record.id)"
              >
                <a>删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
      <span v-else slot="action" slot-scope="text, record">
        --
      </span>
    </a-table>
    <!-- table区域-end -->

    <addSpeechcraft-modal
      :typeList="typeList"
      ref="modalForm"
      @ok="modalFormOk"
    ></addSpeechcraft-modal>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
import {
  addMember,
  editUser,
  queryUserRole,
  queryall,
  querySpeechcraftType,
  querySpeechcraftCategory,
  changeSpeechcraftStatus
} from '@/api/api';

import addSpeechcraftModal from './addSpeechcraftModal';
// import channelModal from './channelModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

export default {
  name: 'speechcraftList',
  mixins: [JeecgListMixin],
  components: {
    addSpeechcraftModal
  },
  // inject: ['reload'],
  data() {
    return {
      description: '这是企业微信话术列表页面',
      queryParam: {
        //筛选要传递的数据
        // key:"",//关键字
        // name:'',//创建人
        // typeId:'',//话术类型id
        // categoryId:'',//话术分类id
        typeList: [] //话术类型列表
      },
      query: {
        pageSizeOptions: ['10', '20', '30'],
        pageNo: 1,
        pageSize: 10,
        total: 0
      },

      columns: [
        {
          title: '话术类型',
          align: 'center',
          dataIndex: 'typeName'
        },
        {
          title: '分类',
          align: 'center',
          dataIndex: 'categoryName'
        },
        {
          title: '话术简述',
          align: 'center',
          dataIndex: 'description',
          ellipsis: true,
          width: 200
        },

        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createName',
          customRender: function(text, record, index) {
            // let list= JSON.parse(sessionStorage.getItem('CREATEPOPLIST'))
            // for (let i = 0; i < list.length; i++) {
            //   if (list[i].userName==text) {
            //     // console.log(list[i].realName);
            //     return list[i].realName
            //   }
            // }
            if (!text) {
              return '--';
            }
            let list = JSON.parse(sessionStorage.getItem('CREATEPOPLIST'));
            let textTemp = text.toLocaleLowerCase();
            let target = list.find(
              item => item.userName.toLocaleLowerCase() == textTemp
            );
            if (target) {
              return target.realName;
            } else {
              return text;
            }
          }
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        // {
        //   title: '累计使用',
        //   align: 'center',
        //   dataIndex: 'ucount',
        // },
        // {
        //   title: '近一月使用',
        //   align: 'center',
        //   dataIndex: 'ccount',
        // },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status'
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      dataSource: [
        // {
        //   cname: '话术1',
        //   ctype: '分类1',
        //   scene: '话术简述1',
        //   needVerify: '创建人1',
        //   ctime: '创建时间1',
        //   ucount: '累计使用1',
        //   ccount: '最近使用1',
        // },
      ],
      url: {
        list: 'wechatwork-users-biz/speechcraft/data',
        delete: 'wechatwork-users-biz/speechcraft/changeSpeechcraftStatus',
        deleteBatch: 'wechatwork-users-biz/wechatwork/channel/deleteBatch'
      },
      visible: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      speechDetail: {},
      typeList: [], //话术类型列表
      spcenList: [] //话术类型列表
      // typeId:'',//选中的话术类型关键字typeId
    };
  },
  // watch:{
  //   'queryParam.createName'(val){
  //     let list= JSON.parse(sessionStorage.getItem('CREATEPOPLIST'))
  //     list.map(item=>{
  //       if(item.realName == val){
  //         this.queryParam.createName = item.userName
  //         console.log("************",this.queryParam.createName)
  //       }
  //     })
  //   }
  // },

  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  mounted() {
    this.getSpeechcraftType();
  },
  methods: {
    typeIdChange(id) {
      //话术类型切换
      this.queryParam.typeId = id;
      this.getSpeechcraftCategory(id);
    },
    categoryChange(id) {
      //话术分类的切换
      console.log(id);
      this.queryParam.category = id;
    },
    getSpeechcraftType() {
      //获取话术类型
      querySpeechcraftType({ pageNo: 1, pageSize: '20' }).then(res => {
        console.log(res);
        if (res.length) {
          this.typeList = res;
          this.queryParam.typeList = this.typeList;
        }
        // if (res.success) {

        // }
      });
    },
    handleView(record) {
      this.$refs.modalForm.viewInfo(record);
    },
    getSpeechcraftCategory(id) {
      // 获取话术分类
      querySpeechcraftCategory({ typeId: id }).then(res => {
        if (res.success) {
          this.spcenList = res.result;
        }
      });
    },
    modalFormOk() {
      //确认回调
      let detail = {
        createName: this.queryParam.name,
        description: this.queryParam.key,
        type: this.queryParam.typeId,
        category: this.queryParam.categoryId
      };
      this.getData(detail);
    },
    // searchQuery(){//搜索查询
    //   let detail = {
    //     createName:this.queryParam.createName,
    //     description:this.queryParam.description,
    //     type:this.queryParam.typeId,
    //     category:this.queryParam.category,
    //   }
    //   this.getData(detail);
    // },
    getData(data) {
      getAction(this.url.list, data || {}).then(res => {
        if (res.success) {
          this.dataSource = res.result.list;
          this.query.total = res.result.total;
          console.log(res, this.query.total, '>>>');
        }
      });
    },

    handleDelete(id) {
      //删除
      changeSpeechcraftStatus({ speechcraftId: id }).then(res => {
        if (res.success) {
          this.$message.success(res.message);
          // this.getData();
          this.searchReset();
          // this.reload();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
